<script setup lang="ts">
import type { SocialNetwork } from '@/store/city/city.types'

type Props = {
  socialNetworks: SocialNetwork[]
}
defineProps<Props>()
</script>

<template>
  <div class="social-networks">
    <a
      v-for="link in socialNetworks"
      :key="link.slug"
      :href="link.url"
      class="social-networks__link"
    >
      <nuxt-img
        :src="link.image"
        :alt="link.slug"
        width="28"
        height="28"
        loading="lazy"
      />
    </a>
  </div>
</template>

<style lang="scss">
.social-networks {
  display: flex;
  gap: 0 20px;
  align-items: center;

  &__link {
    display: flex;
    align-items: center;
  }
}
</style>
